/* global $ */

const $window = $(window);
const $mediaRow = $('.media-row.is-slider .row');

const mediaRowsInst = {
  initialize(el) {
    this.el = el;
    this.$el = $(el);
    this.numberOfSlides = this.$el.children().length;
    this.lastBreakpoint = 'unknown';

    this.createListeners();
    this.calcDimensions();
  },

  /**
   * Create event listeners
   *
   * @return {void}
   */
  createListeners() {
    $window.on('resize', () => {
      this.calcDimensions();
    });
  },

  /**
   * Calculate dimensions
   *
   * @return {void}
   */
  calcDimensions() {
    const newBreakpoint = $window.width() < 768 ? 'sm' : 'lg';

    if (newBreakpoint !== this.lastBreakpoint) {
      this.lastBreakpoint = newBreakpoint;
      this.create();
    }
  },

  /**
   * Create slider
   *
   * @return {void}
   */
  create() {
    if (this.lastBreakpoint === 'sm' || this.numberOfSlides > 4) {
      this.$el.slick({
        slidesToShow: 3,
        arrows: false,
        responsive: [
          {
            breakpoint: 409,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });

      return;
    }

    if (this.$el.hasClass('slick-slider')) {
      this.$el.slick('unslick');
    }
  },
};

export default {
  initialize() {
    $mediaRow.each((i, el) => {
      const inst = { ...mediaRowsInst };
      inst.initialize(el);
    });
  },
};
